import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import * as moment from 'moment';
import { HazardFormFilterService } from './hazard-form-filter.service';
import { environment } from '../../environments/environment';
import { saveAs } from 'file-saver';
import { SubmittedFormListService } from '../submitted-form-list/submitted-forms-list.service';
@Component({
    selector: 'app-hazard-form-filter',
    templateUrl: 'hazard-form-filter.component.html'
})
export class HazardFormListFilterComponent implements OnInit {

    @Input() parentComponentData;

    currentPage: String;
    dropdownSettings = {};

    statusDataList = [];
    // worksAreasDataList = [];
    dateRange = {
        active: false,
        fixed: false
    };
    monthPick: {year: number, month: number};
    PresentDay: any;
    messageFrom: String;
    messageTo: String;
    messagereportFrom: String;
    messagereportTo: String;
    selecteditem: String[] = [];


    selectedReportedFrom = undefined;
    selectedReportedTo = undefined;
    selectedFixedFrom = undefined;
    selectedFixedTo = undefined;
    selectedTaskStatusList = [];
    formType = 'hazard';
    // selectedWorkAreasList = [];

    constructor(
        private _hazardFormFilterService: HazardFormFilterService,
        private _router: Router,
        public activeModal: NgbActiveModal,
        private _submittedFormListService: SubmittedFormListService,
        private route: ActivatedRoute) {
        this.currentPage = this.route.root.firstChild.snapshot.data['currentPage'];
        this.PresentDay = this.getFormattedDate(new Date());
    }

    ngOnInit() {
        // this._hazardFormFilterService.getInitialDataForHazardsFilter()
        //     .subscribe((result: any) => {
        // filter code starts
        if(this.parentComponentData.formType) {
            this.formType = this.parentComponentData.formType;
        }
        this.dropdownSettings = {
            singleSelection: false,
            idField: '_id',
            textField: 'name',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            // itemsShowLimit: 3,
            enableCheckAll: false,
            allowSearchFilter: true
        };
        // this.worksAreasDataList = result.data.workAreasList;
        this.statusDataList = this.formType == 'action' ?  [
            { _id: 'active', name: 'Active Actions' },
            { _id: 'fixed', name: 'Fixed Actions' }
        ] : [
            { _id: 'active', name: 'Active Hazards' },
            { _id: 'fixed', name: 'Fixed Hazards' }
        ];
        this.selectedTaskStatusList = [];
        
        if (this.parentComponentData && this.parentComponentData.queryParams) {
            let parentQueryParams = this.parentComponentData.queryParams;
            console.log('​SubmittedFormListFilterComponent -> ngOnInit -> parentQueryParams', parentQueryParams);
            // Added this for Auto fetching applied list types on opening the popup
            console.log(parentQueryParams, this.selecteditem);
            var items = []
            _.forEach(parentQueryParams.status, function (status) {
                items.push(status.name);
            });
            this.selecteditem = items;
            // end of auto fetching code for selected list
            // tslint:disable-next-line:max-line-length
            this.selectedReportedFrom = parentQueryParams.reportedFrom ? this.getFormattedDate(parentQueryParams.reportedFrom) : undefined;
            this.selectedReportedTo = parentQueryParams.reportedTo ? this.getFormattedDate(parentQueryParams.reportedTo) : undefined;
            this.selectedFixedFrom = parentQueryParams.FixedFrom ? this.getFormattedDate(parentQueryParams.FixedFrom) : undefined;
            this.selectedFixedTo = parentQueryParams.FixedTo ? this.getFormattedDate(parentQueryParams.FixedTo) : undefined;
            this.selectedTaskStatusList = parentQueryParams.status ? parentQueryParams.status : [];
            // this.selectedWorkAreasList = parentQueryParams.wid ? parentQueryParams.wid : [];
            _.forEach(this.selectedTaskStatusList, item => {
                this.setDateRangeVisibility(item);
            });
            // });
        }
        if (this.parentComponentData && this.parentComponentData['filter'] === 'voltas') {
            this.selectedReportedTo = undefined;
            this.selectedReportedFrom = undefined;
        }
    }

    onItemSelect(item: any) {
        console.log(item);
        this.setDateRangeVisibility(item);
        this.selecteditem.push(item.name)
    }

    setDateRangeVisibility(item: any) {
        if (item._id === 'active') {
            this.dateRange.active = true;
        } else if (item._id === 'fixed') {
            this.dateRange.fixed = true;
        }
    }

    onItemDeSelect(item: any) {
        if (item._id === 'active') {
            this.dateRange.active = false;
            this.selectedReportedFrom = undefined;
            this.selectedReportedTo = undefined;
        } else if (item._id === 'fixed') {
            this.dateRange.fixed = false;
            this.selectedFixedFrom = undefined;
            this.selectedFixedTo = undefined;
        }
    }

    getFormattedDate(date) {
        return {
            'year': moment(date).year(),
            'month': moment(date).month() + 1,  // This is because in moment() months numbered from 0 to 11.
            'day': moment(date).date()
        };
    }

    getFilteredData() {
        if (this.parentComponentData && this.parentComponentData.queryParams) {
            let isFilters = 'false';
            // tslint:disable-next-line:max-line-length && _.isEmpty(this.selectedWorkAreasList)
            if (_.isEmpty(this.selectedTaskStatusList) && !this.selectedReportedFrom && !this.selectedReportedTo && !this.selectedFixedFrom && !this.selectedFixedTo) {
                isFilters = 'false';
            } else {
                isFilters = 'true';
            }

            if (this.selecteditem.indexOf('Active Hazards') > -1) {
                // console.log("submitted", this.selectedReportedFrom, this.selectedReportedTo);
                this.messageFrom = "";
                this.messageTo = "";
                if ((this.selectedReportedFrom && !this.selectedReportedTo) || (!this.selectedReportedFrom && this.selectedReportedTo)) {
                    if (!this.selectedReportedFrom) {
                        this.messagereportFrom = "Select Date";
                        return;
                    }
                    if (!this.selectedReportedTo) {
                        this.messagereportTo = "Select Date";
                        return;
                    }
                }
            }

            if (this.selecteditem.indexOf('Fixed Hazards') > -1) {
                // console.log("Reviewed", this.selectedFixedFrom, this.selectedFixedTo)

                if ((this.selectedFixedFrom && !this.selectedFixedTo) || (!this.selectedFixedFrom && this.selectedFixedTo)) {
                    this.messagereportFrom = "";
                    this.messagereportFrom = "";
                    // console.log(this.selectedFixedFrom, this.selectedFixedTo);
                    if (!this.selectedFixedFrom) {
                        this.messageFrom = "Select Date";
                        return;
                    }
                    if (!this.selectedFixedTo) {
                        this.messageTo = "Select Date";
                        return;
                    }
                }
            }

            let redirectUrl;
            if (this.parentComponentData['queryParams']['filter'] === 'Voltas') {
                this.downLoadExcelFile();
                this.close();
                return;
            } else if(this.parentComponentData['queryParams']['filter'] === 'dyno') {
                this.downloadDynoDailyActivityReport();
                this.close()
            } else {
                if(this.formType == "action") {
                    redirectUrl = '/actions/' 
                } else {
                    redirectUrl = '/hazards/'
                }
                redirectUrl += this.parentComponentData.templateId + `?formType=${this.formType}&filter=` + isFilters;
                _.forEach(this.selectedTaskStatusList, (status) => {
                    redirectUrl = redirectUrl.concat('&status=' + status._id);
                });
            }
            // _.forEach(this.selectedWorkAreasList, (workArea) => {
            //     redirectUrl = redirectUrl.concat('&wid=' + workArea._id);
            //     redirectUrl = redirectUrl.concat('&' + workArea._id + '=' + encodeURI(workArea.name));
            // });
            if (this.selectedReportedFrom && this.selectedReportedTo) {
                redirectUrl = redirectUrl.concat('&reportedFrom=' + this.getFormatedDate(this.selectedReportedFrom, 'START'));
                redirectUrl = redirectUrl.concat('&reportedTo=' + this.getFormatedDate(this.selectedReportedTo, 'END'));
            }
            if (this.selectedFixedFrom && this.selectedFixedTo) {
                redirectUrl = redirectUrl.concat('&FixedFrom=' + this.getFormatedDate(this.selectedFixedFrom, 'START'));
                redirectUrl = redirectUrl.concat('&FixedTo=' + this.getFormatedDate(this.selectedFixedTo, 'END'));
            }
            this._router.navigateByUrl(redirectUrl);
        }
        this.close();
    }

    downLoadExcelFile() {
        let voltasBetweenDates = {
            templateId: this.parentComponentData.templateId,
            teamId: localStorage.getItem('teamId'),
            reportType: this.parentComponentData['queryParams']['reportType']
        }
        if(this.parentComponentData['queryParams']['type'] === 'daily'){
            voltasBetweenDates['from'] = this.getFormatedDate(this.selectedReportedFrom, 'START');
            this.selectedReportedFrom.month += 1;
            voltasBetweenDates['to'] = this.getFormatedDate(this.selectedReportedFrom, 'END');
            voltasBetweenDates['type'] = 'daily';
        } else {
            this.monthPick.month = this.monthPick.month - 1;
            voltasBetweenDates['from'] = moment(this.monthPick).startOf('months').utc().format()//this.getFormatedDate(this.monthPick, 'START');
            voltasBetweenDates['to'] = moment(this.monthPick).endOf('months').utc().format();
            voltasBetweenDates['type'] = 'monthly';
        }
        this._submittedFormListService.downloadvoltasAvailabilityExcel(voltasBetweenDates)
            .subscribe((result: any) => {
                let folderName = '';
                folderName = (environment.APP_NAME || '') + ' ' + (voltasBetweenDates['type']).toUpperCase() + ' Report ' + moment(Date.now()).format('MM-DD-YYYY hh.mm A');
                const blob = new Blob([result], {
                    type: 'application/xlsx'//'application/zip;charset=utf-8'
                });
                saveAs(blob, `${folderName}.xlsx`);
                this._router.navigateByUrl('/submittedFormList/' + this.parentComponentData.templateId);
            }, (err) => {
                console.log('SubmittedFormPreviewComponent -> ngOnInit -> ', err);
                this._router.navigateByUrl('/submittedFormList/' + this.parentComponentData.templateId);
            });
    }

    resetError(type) {
        console.log(type);
        switch (type) {
            case "reportedFrom":
                this.messagereportFrom = "";
                break;
            case "reportedTo":
                this.messagereportTo = "";
                break;
            case "fixedFrom":
                this.messageFrom = "";
                break;
            case "fixedTo":
                this.messageTo = "";
                break;
        }
    }

    getFormatedDate(date: any, type) {
        date.month = date.month - 1;  // This is because in moment() months numbered from 0 to 11.
        if (type === 'START') {
            return moment(date).utc().format();
        }
        if (type === 'END') {
            return moment(date).endOf('d').utc().format();
        }
    }

    clearDateData(abc) {
        this[abc] = undefined;
    }

    close() {
        this.clearFilters();
        this.activeModal.dismiss();
    }

    clearFilters() {
        this.selectedTaskStatusList = [];
        // this.selectedWorkAreasList = [];
        this.selectedReportedFrom = undefined;
        this.selectedReportedTo = undefined;
        this.selectedFixedFrom = undefined;
        this.selectedFixedTo = undefined;
        this.messageFrom = "";
        this.messageTo = "";
        this.messagereportFrom = "";
        this.messagereportTo = "";
    }

    downloadDynoDailyActivityReport() {
        let requestObj = {
            teamId: localStorage.getItem("teamId"),
        }

        if(this.parentComponentData['queryParams']['type'] === 'daily') {
            requestObj['date'] = this.selectedReportedFrom
        }
        this._submittedFormListService.downloadDynoDailyActityReport(requestObj).toPromise().then((data) => {
            
            let folderName = '';
            folderName =(environment.APP_NAME || '') + ' Dyno Daily Activity Report ' + moment(Date.now()).format('MM-DD-YYYY hh.mm A');
            const blob = new Blob([data], {
                type: 'application/zip;charset=utf-8'
            });
            saveAs(blob, `${folderName}.pdf`);
        }, (error) => {
            console.log("No reports found or error occured", error)
            
        })
    }
}




// WEBPACK FOOTER //
// ./src/app/hazard-form-filter/hazard-form-filter.component.ts